// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';
import { normalizeDateTime } from '@/utilities/date-time';
import { DateTime } from 'luxon';

export interface AssetAssignment {
  assetId: string;
  date: DateTime;
}

/**
 * Updates an existing project in the remote API.
 *
 * @param key - The key of the project for which the assets are being assigned.
 * @param assignments - A collection of asset assignments representing an asset
 * ID and an effective assignment date.
 */
export async function assignAssets(
  key: string,
  assignments: AssetAssignment[]
) {
  const url = `/v1/project/${key}/asset`;
  const response = await api.post(
    url,
    assignments.map(({ assetId, date }) => ({
      assetId,
      effectiveDate: normalizeDateTime(date).toISO(),
    }))
  );

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'AssignAssets',
    endpoint: url,
  });
}
